import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CorePipesModule } from '@core/pipes/pipes.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CorePipesModule],
  exports: [CommonModule, FormsModule, ReactiveFormsModule, CorePipesModule],
})
export class CoreCommonModule {}
